import { render, staticRenderFns } from "./CreateLoggedParameter.vue?vue&type=template&id=6a32177b&scoped=true"
import script from "./CreateLoggedParameter.vue?vue&type=script&lang=js"
export * from "./CreateLoggedParameter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a32177b",
  null
  
)

export default component.exports